"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceList = exports.Device = exports.SyncRo = exports.HydroTapBridge = exports.Blackbox = exports.Gbfc = exports.Pelican2 = exports.deviceListFields = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const device_1 = require("../../device");
exports.NAMESPACE = 'Culligan.Api.Device.DeviceList';
exports.deviceListFields = [
    'id',
    'model',
    'assetTag',
    'installationStatus',
    'installationUpdatedAt',
    'manufacturingSerialNumber',
    'providedLocation',
    'installationAddress',
    'contactInfo',
    'detectedLocation',
    'tenantId',
    'connectionStatus',
    'vendor',
    'businessUnit',
    'state',
    'swVersion',
];
const extractDeviceListFields = (deviceFields) => {
    return effect_1.Struct.pick(deviceFields, ...exports.deviceListFields);
};
class Pelican2 extends effect_1.Schema.Class(`${exports.NAMESPACE}.Pelican2`)({
    ...extractDeviceListFields(device_1.Class.Pelican2.Pelican2.fields),
    alarms: effect_1.Schema.Struct({
        critical: effect_1.Schema.Number,
        nonCritical: effect_1.Schema.Number,
    }),
    errors: effect_1.Schema.Number,
}) {
    static Device = device_1.Class.Pelican2.Pelican2;
}
exports.Pelican2 = Pelican2;
class Gbfc extends effect_1.Schema.Class(`${exports.NAMESPACE}.Gbfc`)({
    ...extractDeviceListFields(device_1.Class.Gbfc.Gbfc.fields),
    alarms: effect_1.Schema.Struct({
        critical: effect_1.Schema.Number,
        nonCritical: effect_1.Schema.Number,
    }),
    errors: effect_1.Schema.Number,
}) {
    static Device = device_1.Class.Gbfc.Gbfc;
}
exports.Gbfc = Gbfc;
class Blackbox extends effect_1.Schema.Class(`${exports.NAMESPACE}.Blackbox`)({
    ...extractDeviceListFields(device_1.Class.Blackbox.Blackbox.fields),
    alarms: effect_1.Schema.Struct({
        critical: effect_1.Schema.Number,
        nonCritical: effect_1.Schema.Number,
    }),
    errors: effect_1.Schema.Number,
}) {
    static Device = device_1.Class.Blackbox.Blackbox;
}
exports.Blackbox = Blackbox;
class HydroTapBridge extends effect_1.Schema.Class(`${exports.NAMESPACE}.HydroTapBridge`)({
    ...extractDeviceListFields(device_1.Class.HydroTapBridge.HydroTapBridge.fields),
    alarms: effect_1.Schema.Struct({
        critical: effect_1.Schema.Number,
        nonCritical: effect_1.Schema.Number,
    }),
    errors: effect_1.Schema.Number,
}) {
    static Device = device_1.Class.HydroTapBridge.HydroTapBridge;
}
exports.HydroTapBridge = HydroTapBridge;
class SyncRo extends effect_1.Schema.Class(`${exports.NAMESPACE}.SyncRo`)({
    ...extractDeviceListFields(device_1.Class.SyncRo.SyncRo.fields),
    alarms: effect_1.Schema.Struct({
        critical: effect_1.Schema.Number,
        nonCritical: effect_1.Schema.Number,
    }),
    errors: effect_1.Schema.Number,
}) {
    static Device = device_1.Class.SyncRo.SyncRo;
}
exports.SyncRo = SyncRo;
exports.Device = effect_1.Schema.Union(Pelican2, Gbfc, Blackbox, HydroTapBridge, SyncRo).annotations({
    identifier: `${exports.NAMESPACE}.Device`,
});
exports.DeviceList = effect_1.Schema.Array(exports.Device).annotations({
    identifier: `${exports.NAMESPACE}.DeviceList`,
});
//# sourceMappingURL=deviceList.js.map